import { Chain } from './common'

export enum walletActions {
  action = 'wallet_action',
  status = 'status',
  lock = 'lock',
  unlock = 'unlock',
  create = 'create',
  export = 'export',
  import = 'import',
  changePassword = 'changePassword',
  transferToken = 'transferToken',
  transferEth = 'transferEth',
  transferErc20 = 'transferErc20',
  approveErc20 = 'approveErc20',
  depositErc20 = 'depositErc20',
  transferBTC = 'transferBTC',
  transferOrdinal = 'transferOrdinal',
  sendSol = 'sendSol',
  mintCkETH = 'mintCkETH',
  approveToken = 'approveToken',
  sendNFT = 'sendNFT',
  exportKeychain = 'exportKeychain',
  exportPem = 'exportPem',
  importPem = 'importPem',
  burnXTC = 'burnXTC',
  getPrincipals = 'getPrincipals',
  getIdentity = 'getIdentity',
  addAccount = 'addAccount',
  signMessage = 'signMessage',
  clearKeychain = 'clearKeychain',
  ethCallContract = 'ethCallContract',
  customApproveErc20 = 'customApproveErc20',
}

export type WalletAction = keyof typeof walletActions

interface PaymentActionParams {
  tokenCanisterId?: string
  standard: string
  amount: string
}

interface Account {
  address: string
  subaccount?: number[]
}

export interface SendEthParams {
  address: string
  amount: string
  gasLimit?: string
  maxFeePerGas?: string
  maxPriorityFeePerGas?: string
  nonce: number
  chain: Chain
}

export interface SendErc20Params {
  amount: string
  gasLimit: string
  maxFeePerGas: string
  maxPriorityFeePerGas: string
  nonce: string
  contractAddress: string
  receiver: string
  chain: Chain
}

export interface EthCallContractParams {
  value: string
  gasLimit: string
  maxFeePerGas: string
  maxPriorityFeePerGas: string
  nonce: string
  contractAddress: string
  data: string
  chain: Chain
}

export interface PersonalSignParams {
  message: string
}

export interface CustomDepositErc20Params {
  value: string
  gasLimit: string
  maxFeePerGas: string
  maxPriorityFeePerGas: string
  nonce: string
  contractAddress: string
  chain: Chain
}

export interface CustomApproveErc20Params {
  value: string
  gasLimit: string
  maxFeePerGas: string
  maxPriorityFeePerGas: string
  nonce: string
  contractAddress: string
  spender: string
  chain: Chain
}

export type ApproveErc20Params = Omit<SendErc20Params, 'receiver'>

export type MintCkEthParams = Omit<SendEthParams, 'address'>

export interface SendParams extends PaymentActionParams {
  receiver: Account
  memo?: number
  tokenId?: string
  chain?: Chain
}

export interface ApproveParams extends PaymentActionParams {
  expiresAt?: number
  spender: Account
}

export interface CreateWalletResponse {
  mnemonic: string
  principal: string
}

export interface ImportWalletResponse {
  principal: string
}

export interface WalletStatusResponse {
  isReady: boolean
  hasVault: boolean
  hasPassword: boolean
  unlocked: boolean
}

export interface NftSendParams {
  canisterId: string
  receiverPrincipal: string
  nftIndex: string
  standard: string
}

export interface ExportKeychainParams {
  principal: string
  password: string
}

export interface XTCBurnParams {
  principal: string
  amount: string
}

export interface BTCSendParams {
  to: string
  amount: string
  fee: string
  utxos: UTXO[]
}

export interface BTCSendOrdinalParams {
  to: string
  fee: string
  ordinalUtxo: UTXO
  feeUtxo: UTXO
}

export interface SolSendParams {
  from: string
  to: string
  amount: string
}

export interface UTXO {
  mintTxid: string
  mintIndex: number
  mintHeight: number
  script: string
  value: number
  address: string
}

export interface SignMessageParams {
  principalId: string
  message: string
}
